import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

/**
 * Global Error Boundary — catches React render / lifecycle errors
 * and prevents the entire site from going blank white.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        data-testid="error-boundary-fallback"
        className="min-h-screen flex items-center justify-center bg-slate-50 px-4"
      >
        <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center border border-slate-200">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-red-600" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">
            Bir sorun oluştu
          </h1>
          <p className="text-slate-600 mb-6">
            Sayfayı yüklerken beklenmedik bir hata meydana geldi. Sayfayı yenilemeyi veya
            ana sayfaya dönmeyi deneyebilirsiniz.
          </p>
          {process.env.NODE_ENV !== 'production' && this.state.error && (
            <pre className="text-xs text-left bg-slate-100 p-3 rounded mb-4 overflow-auto max-h-32 text-red-700">
              {String(this.state.error?.message || this.state.error)}
            </pre>
          )}
          <div className="flex flex-col sm:flex-row gap-2 justify-center">
            <button
              data-testid="error-reload-btn"
              onClick={this.handleReload}
              className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 transition"
            >
              <RefreshCw className="w-4 h-4" />
              Sayfayı Yenile
            </button>
            <button
              data-testid="error-home-btn"
              onClick={this.handleHome}
              className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-slate-200 text-slate-800 hover:bg-slate-300 transition"
            >
              <Home className="w-4 h-4" />
              Ana Sayfa
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
